/* 🤖 this file was generated by svg-to-ts */
export const siriusDeviceDuotone: {
  name: 'device_duotone';
  data: string;
} = {
  name: 'device_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M18 5.25H6v13.5h12V5.25Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.25 3.75v16.5A2.25 2.25 0 0 0 7.5 22.5h9a2.25 2.25 0 0 0 2.25-2.25V3.75A2.25 2.25 0 0 0 16.5 1.5h-9a2.25 2.25 0 0 0-2.25 2.25ZM7.5 3a.75.75 0 0 0-.75.75v.75h10.5v-.75A.75.75 0 0 0 16.5 3h-9Zm9.75 15V6H6.75v12h10.5Zm-10.5 1.5h10.5v.75a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1-.75-.75v-.75Z" fill="currentColor"/></svg>`
};
